// App.jsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import FormPage from "./pages/FormPage";
import ScanRepo from "./pages/ScanRepo.js";
import Home from "./pages/Home.js";
import UploadZip from "./pages/UploadZip.js";
import ReportList from "./pages/ReportList.js";
import SidebarLayout from "./pages/SidebarLayout.js";
import GitHubConnections from "./pages/GitHubConnections.js";
import BitBucketConnections from "./pages/BitBucketConnections.js";
import UserManagement from "./pages/UserManagement.js";
import ProtectedRoute from "./components/common/ProtectedRoute";
import Credentials from "./pages/Credentials.js";
import AwsAlbManager from "./pages/AwsAlbManager.js";
import SlackCallback from "./pages/SlackCallback.js";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <SidebarLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="home" />} />
          <Route path="home" element={<Home />} />
          <Route path="scan-repo" element={<ScanRepo />} />
          <Route path="upload-zip" element={<UploadZip />} />
          <Route path="report-list" element={<ReportList />} />
          <Route path="github-connections" element={<GitHubConnections />} />
          <Route path="bitbucket-connections" element={<BitBucketConnections />} />
          <Route path="credentials" element={<Credentials />} />
          <Route path="aws-alb-manager" element={<AwsAlbManager />} />
          <Route path="/slack-callback" element={<SlackCallback />} />
          <Route path="user-management" element={<UserManagement />} />
        </Route>

        <Route path="/form" element={<FormPage />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
